module.exports = __webpack_public_path__ + "static/media/U1-T2-2-3b.ebb43907.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-3b.svg
// module id = 549
// module chunks = 0